export default __webpack_public_path__ + "static/media/335e62eaeb088ad5a318a77c5c78dac8.svg";